import React, { useEffect, useState } from "react";
import { isLoggedIn, logOut } from "../services/authService";
import PageLoader from "../components/loader";

let logoutTimer;

const WATCHED_EVENTS = [
  "onload",
  "load",
  "mousemove",
  "mousedown",
  "mouseenter",
  "mouseleave",
  "mouseover",
  "click",
  "scroll",
  "keypress",
];

// Removed automatic token refresh - now handled by SessionWarningProvider
// Token refresh only happens when user is active
const IDLE_TIMEOUT = 5 * 60 * 1000;
const LOCAL_IDLE_TIMEOUT = 60 * 60 * 1000;
const QA_IDLE_TIMEOUT = 60 * 60 * 1000;

const AppKeepAlive = ({ children }) => {
  const [loading, setLoading] = useState(true);

  const logout = () => {
    window.clearTimeout(logoutTimer);
    logOut();
  };

  const setAppTimeout = () => {
    logoutTimer = window.setTimeout(
      logout,
      window.location.origin?.includes("localhost")
        ? LOCAL_IDLE_TIMEOUT
        : window.location.origin?.includes("qa") ? QA_IDLE_TIMEOUT : IDLE_TIMEOUT
    );
  };

  // Removed automatic token refresh - now handled by SessionWarningProvider
  // Token refresh only happens when user is active

  const resetTimer = () => {
    window.clearTimeout(logoutTimer);
    setAppTimeout();
  };

  useEffect(() => {
    for (let i in WATCHED_EVENTS) {
      window.addEventListener(WATCHED_EVENTS[i], resetTimer);
    }

    return () => {
      window.clearTimeout(logoutTimer);
      for (let i in WATCHED_EVENTS) {
        window.removeEventListener(WATCHED_EVENTS[i], resetTimer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isLoggedIn()) {
      setLoading(false);
      setAppTimeout();
    }
    else {
      logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return loading ? <PageLoader /> : <> {children}</>;
};

export default AppKeepAlive;
